import { FC } from "react";
import { NativeProps, render } from "@/utils/components-utils";
import { useTranslation } from "next-i18next";

export type SelectedItem = {
	label: string;
	value: string;
	acronym?: string;
};
type Props = {
	onSelected: (value: SelectedItem) => void;
	list: SelectedItem[];
	renderOption?: (option: SelectedItem) => React.ReactNode;
} & NativeProps;

export const SelectView: FC<Props> = ({ onSelected, list, renderOption }) => {
	const { t } = useTranslation("common");
	return (
		<ul className="hidden-scroll-bar mt-4 h-[70vh] overflow-y-auto px-3 pb-4 text-sm inter-text">
			{list.map((item, index) => {
				return (
					<li
						key={index}
						onClick={(e) => {
							onSelected(item);
						}}
						className="px-4 py-3 active:font-bold dark:active:text-white active:text-dark f2_19_bottom_50"
					>
						{renderOption ? renderOption(item) : item.label}
					</li>
				);
			})}

			{list.length === 0 && <p className="mt-4 text-center">{t("nothing-here")}</p>}
		</ul>
	);
};
